'use es6';

import CustomWidgetTags from 'ContentUtils/constants/CustomWidgetTags';
export default Object.freeze(Object.assign({}, CustomWidgetTags, {
  CUSTOM_MODULE_MAP: CustomWidgetTags.MAP
}));